export default __webpack_public_path__ + "static/media/logo.0413beba.png";